<template>
  <div class="car-series-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>车系列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡片 -->
    <el-card class="main-card" shadow="never">
      <!-- 搜索栏和操作栏 -->
      <div class="search-bar-wrapper">
        <el-form :inline="true" :model="searchForm" size="small" label-width="0">
          <el-form-item>
            <el-input
              v-model="searchForm.name"
              placeholder="请输入车系名称"
              clearable
              @keyup.enter.native="searchSubmit"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchSubmit"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="addData">新增车系</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格（树形结构） -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        row-key="id"
        size="small"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        class="data-table"
      >
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod">
        </el-table-column>
        <el-table-column label="分类名称" prop="name" min-width="160">
          <template slot-scope="{ row }">
            <span class="link-text" @click="handelEdit(row)">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="200"></el-table-column>
        <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handelEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger-text" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <!-- <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div> -->
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="520px" custom-class="custom-dialog">
      <el-form :model="ruleForm" :rules="rules" ref="form" label-width="80px" size="small">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入分类名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="ruleForm.sort" placeholder="请输入排序值" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="parent_id">
          <el-select v-model="ruleForm.parent_id" placeholder="请选择上级分类" clearable>
            <el-option
              v-for="item in cateMenus"
              :key="item.id"
              :label="item.pid > 0 ? '|--' + item.name : item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="reset_dialogForm('form')">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'carStyleList',
  data() {
    return {
      searchForm: {
        name: '',
      },
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: '',
      dialogFormVisible: false,
      ruleForm: {
        id: '',
        name: '',
        parent_id: '',
        remark: '',
        sort: '',
      },
      cateMenus: [],
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.DataList();
    this.getCateMenus();
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    DataList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        keywords: this.searchForm.name,
      };
      this.$axios
        .findCarStyleTree(param)
        .then((res) => {
          if (res.code === 200) {
            this.tableLoadData = res.data || [];
            this.total = res.data?.length || 0;
          }
        })
        .catch((err) => console.error(err));
    },
    getCateMenus() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      };
      this.$axios
        .findCarStyleTable(param)
        .then((res) => {
          if (res.code === 200) {
            this.cateMenus = res.data || [];
          }
        })
        .catch((err) => console.error(err));
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNum = 1;
      this.DataList();
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.DataList();
    },
    addData() {
      this.title = '新增车系';
      this.ruleForm = {
        id: '',
        name: '',
        remark: '',
        sort: '1',
        parent_id: '',
      };
      this.dialogFormVisible = true;
    },
    handelEdit(row) {
      this.title = '编辑车系';
      this.ruleForm = {
        id: row.id,
        name: row.name,
        remark: row.remark,
        sort: row.sort,
        parent_id: row.pid,
      };
      this.dialogFormVisible = true;
    },
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => {
        this.$refs[formName]?.resetFields();
      });
    },
    submitForm(formName) {

        


      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            id: this.ruleForm.id,
            name: this.ruleForm.name,
            parent_id: this.ruleForm.parent_id,
            remark: this.ruleForm.remark,
            sort: this.ruleForm.sort,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          };
        
          this.$axios
            .carStyleSave(param)
            .then((res) => {

              if (res.code === 200) {
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
                this.DataList();
                this.getCateMenus(); // 刷新上级分类下拉
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(() => this.$message.error('保存失败'));
        }
      });
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },
    del(row) {
      this.$confirm('此操作将永久删除该车系，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: row.id,
          };
          this.$axios
            .carStyleDel?.(param) // 请根据实际API方法名调整
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(res.msg);
                this.DataList();
                this.getCateMenus();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(() => this.$message.error('删除失败'));
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
  },
};
</script>

<style scoped>
/* 支付宝风格整体容器 */
.car-series-container {
  background: #f5f7fa;
  padding: 24px;
  min-height: 100vh;
}

/* 面包屑样式 */
.el-breadcrumb {
  margin-bottom: 16px;
}
.el-breadcrumb__item {
  font-size: 13px;
}

/* 主卡片 */
.main-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.2s;
}
.main-card ::v-deep .el-card__body {
  padding: 24px;
}

/* 搜索栏 */
.search-bar-wrapper {
  margin-bottom: 24px;
}
.el-form-item {
  margin-bottom: 0;
  margin-right: 12px;
}
.el-input {
  width: 260px;
}
.el-input__inner {
  border-radius: 8px;
  height: 32px;
  line-height: 32px;
}
.el-input-group__append {
  background: #1677ff;
  border-color: #1677ff;
  border-radius: 0 8px 8px 0;
}
.el-input-group__append .el-button {
  color: #fff;
  padding: 7px 12px;
}
.el-button--small {
  border-radius: 20px;
  padding: 7px 18px;
}
.el-button--primary {
  background: #1677ff;
  border-color: #1677ff;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: #4096ff;
  border-color: #4096ff;
}

/* 表格美化 */
.data-table {
  border-radius: 12px;
  overflow: hidden;
  font-size: 13px;
}
.data-table ::v-deep .el-table__header th {
  background: #f8fafc;
  color: #2c3e50;
  font-weight: 500;
  border-bottom: 1px solid #edf2f7;
}
.data-table ::v-deep .el-table__body tr:hover > td {
  background: #fafcff;
}
.link-text {
  color: #1677ff;
  cursor: pointer;
  font-weight: 500;
}
.link-text:hover {
  text-decoration: underline;
}
.danger-text {
  color: #f56c6c;
}
.danger-text:hover {
  color: #ff4d4f;
}

/* 分页 */
.pagination-wrapper {
  margin-top: 24px;
  text-align: right;
}
.pagination-wrapper ::v-deep .el-pagination__total,
.pagination-wrapper ::v-deep .el-pagination__sizes .el-select .el-input__inner {
  font-size: 12px;
}
.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1677ff;
}

/* 弹窗美化 */
.custom-dialog {
  border-radius: 20px;
}
.custom-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #edf2f7;
  padding: 16px 20px;
}
.custom-dialog ::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: 500;
  color: #1f2e3d;
}
.custom-dialog ::v-deep .el-dialog__body {
  padding: 20px;
}
.custom-dialog ::v-deep .el-form-item__label {
  font-size: 13px;
  color: #5a6874;
}
.custom-dialog ::v-deep .el-input__inner {
  border-radius: 8px;
}
.dialog-footer {
  text-align: right;
  padding-top: 8px;
}
.dialog-footer .el-button {
  border-radius: 20px;
  padding: 8px 20px;
}
.dialog-footer .el-button--primary {
  background: #1677ff;
  border-color: #1677ff;
}
</style>